import React, { useState, useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Link } from "react-router-dom";

// Bilder
import RENOVIERUNG from "../assets/renovierung.jpeg";
import TROCKENBAU from "../assets/trockenbau.jpeg";
import BODEN from "../assets/bodenleger.jpeg";
import MALEREI from "../assets/malerei.jpg";
import MALEREI2 from "../assets/malerei3.jpg";
import MALEREI3 from "../assets/project_img/malerei_neu1.jpeg"
import FLIESENLEGER from "../assets/fliesenleger.jpg";
import HINTERGRUND from "../assets/hintergrund.jpeg";

// Firmenlogos
import LOGO1 from "../assets/logo1.webp";
import LOGO2 from "../assets/logo2.png";
import LOGO3 from "../assets/logo3.png";
import LOGO4 from "../assets/logo4.jpg";
import LOGO5 from "../assets/logo5.jpg";
import LOGO6 from "../assets/logo6.png";

//Galerie
import FLIESEN1 from "../assets/project_img/fliesen_img.jpg";
import FLIESEN2 from "../assets/project_img/fliesen_2_img.jpg";
import FLIESEN3 from "../assets/project_img/fliesen_3_img.jpg";
import FLIESEN4 from "../assets/project_img/fliesen_img.jpg";
import FLIESEN5 from "../assets/project_img/fliesen_5_img.jpeg"
import FLIESEN6 from "../assets/project_img/fliesen_6_img.jpeg"
import FLIESEN7 from "../assets/project_img/fliesen_7_img.jpeg"

import BODEN1 from "../assets/project_img/boden_1_img.jpg";
import BODEN2 from "../assets/project_img/boden_2_img.jpg";
import BODEN3 from "../assets/project_img/boden_3_img.jpg";
import BODEN4 from "../assets/project_img/boden_4_img.jpeg"
import BODEN5 from "../assets/project_img/boden_5_img.jpeg"
import BODEN6 from "../assets/project_img/boden_6_img.jpeg"
import BODEN7 from "../assets/project_img/boden_img_7.jpeg"
import BODEN8 from "../assets/project_img/boden_8_img.jpeg"
import BODEN9 from "../assets/project_img/boden_9_img.jpeg"

import RENO1 from "../assets/project_img/renovierung_img.jpg";
import RENO2 from "../assets/project_img/renovierung_2_img.jpg";
import RENO3 from "../assets/project_img/renovierung_3_img.jpg";
import RENO4 from "../assets/project_img/renovierung_4_img.jpeg"
import RENO5 from "../assets/project_img/renovierung_5_img.jpeg"
import RENO6 from "../assets/project_img/renovierung_6_img.jpeg"
import RENOFERTIG from "../assets/project_img/reno_fertig_img.jpg";
import SANO1 from "../assets/project_img/PHOTO-2026-01-09-18-11-32[3].jpg";
import SANO2 from "../assets/project_img/PHOTO-2026-01-09-18-11-32[4].jpg";
import HAUS from "../assets/project_img/haus1.jpg";

import TROCKEN1 from "../assets/project_img/troken_1_img.jpg";
import TROCKEN2 from "../assets/project_img/trocken_2_img.jpg";
import TROCKEN3 from "../assets/project_img/trocken_3_img.jpg";
import TROCKEN4 from "../assets/project_img/trocken_4_img.jpeg";
import TROCKEN5 from "../assets/project_img/trocken_5_img.jpeg";
import TROCKEN6 from "../assets/project_img/trocken_6_img.jpeg";

const images = [
  RENOVIERUNG,
  TROCKENBAU,
  BODEN,
  MALEREI,
  FLIESENLEGER,
  HINTERGRUND
];

const imageClass =
  "w-full h-72 sm:h-80 md:h-96 lg:h-[28rem] xl:h-[32rem] object-cover transition duration-300 hover:scale-105";

const videoClass =
  "w-full h-72 sm:h-80 md:h-96 lg:h-[28rem] xl:h-[32rem] object-cover";


const About: React.FC = () => {
  const [current, setCurrent] = useState(0);

  // SLIDESHOW
  useEffect(() => {
    const interval = setInterval(() => {
      setCurrent((prev) => (prev + 1) % images.length);
    }, 4000);
    return () => clearInterval(interval);
  }, []);
  
  return (
    <div className="space-y-20">

      {/* HERO SECTION */}
      <section
        className="relative flex items-center justify-center text-center
                  h-[50vh] md:h-[60vh] sm:h-[40vh]"
        style={{
          backgroundImage: `url(${HINTERGRUND})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
        }}
      >
        <div className="absolute inset-0 bg-black/60"></div>

        <div className="relative max-w-6xl mx-auto px-4 sm:px-6 py-20 md:py-28 text-center">
          <h1 className="text-4xl md:text-4xl font-bold text-white mb-4">
            Über uns
          </h1>
          <p className="text-lg text-gray-200 leading-relaxed">
            Seit unserer Gründung im Jahr <strong>2017</strong> stehen wir für
            Qualität, Zuverlässigkeit und individuelle Lösungen.
          </p>
        </div>
      </section>

      <div className="container mx-auto px-4 space-y-20">

        {/* ÜBER UNS TEXT */}
        <section className="text-center max-w-3xl mx-auto">
          <p className="text-lg text-gray-600 leading-relaxed">
            Unser Ziel ist es, Unternehmen dabei zu unterstützen, ihre Projekte
            erfolgreich umzusetzen – von der ersten Idee bis zur finalen Umsetzung.
            Mit Erfahrung, Engagement und einem hohen Qualitätsanspruch schaffen
            wir nachhaltige Ergebnisse.
          </p>
        </section>

        {/* ================= PROJEKT GALERIE ================= */}
        {/* PROJEKTE */}
        <section className="space-y-20">
          <h2 className="text-3xl font-bold text-center">Unsere Projekte</h2>

          {/* RENOVIERUNG */}
          <div className="space-y-6">
            <h3 className="text-2xl font-semibold">Renovierung & Sanierung</h3>
            <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-4">
              {[RENO1, RENO2, RENO3, RENO4, RENO5, RENO6, HAUS, RENOFERTIG].map(
                (img, i) => (
                  <div key={i} className="overflow-hidden rounded-xl shadow">
                    <img src={img} alt="Renovierung" className={imageClass} />
                  </div>
                )
              )}
            </div>
          </div>

          {/* TROCKENBAU */}
          <div className="space-y-6">
            <h3 className="text-2xl font-semibold">Trockenbau & Innenausbau</h3>
            <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-4">
              {[TROCKEN1, TROCKEN2, TROCKEN3, TROCKEN4, TROCKEN5, TROCKEN6].map(
                (img, i) => (
                  <div key={i} className="overflow-hidden rounded-xl shadow">
                    <img src={img} alt="Trockenbau" className={imageClass} />
                  </div>
                )
              )}
            </div>
          </div>

          {/* BODEN */}
          <div className="space-y-6">
            <h3 className="text-2xl font-semibold">Boden- & Fliesenarbeiten</h3>
            <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-4">
              {[BODEN, BODEN2, BODEN3, BODEN4, BODEN5, BODEN6, BODEN7, BODEN8, BODEN9,
                FLIESEN1, FLIESEN2, FLIESEN3, FLIESEN4, FLIESEN5, FLIESEN6, FLIESEN7].map(
                (img, i) => (
                  <div key={i} className="overflow-hidden rounded-xl shadow">
                    <img src={img} alt="Bodenarbeiten" className={imageClass} />
                  </div>
                )
              )}
            </div>
          </div>

          {/* MALEREI */}
          <div className="space-y-6">
            <h3 className="text-2xl font-semibold">Malerei & Oberflächen</h3>
            <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-4">
              {[MALEREI, MALEREI2, MALEREI3, RENOVIERUNG].map((img, i) => (
                <div key={i} className="overflow-hidden rounded-xl shadow">
                  <img src={img} alt="Malerei" className={imageClass} />
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* VIDEOS */}
        <section className="space-y-10">
          <h2 className="text-3xl font-bold text-center">Projektvideos</h2>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-6 max-w-4xl mx-auto">
            {["/videos/video1.mp4", "/videos/video2.mp4"].map((src, i) => (
              <div key={i} className="rounded-2xl overflow-hidden shadow-lg">
                <video
                  muted
                  autoPlay
                  loop
                  playsInline
                  className={videoClass}
                >
                  <source src={src} type="video/mp4" />
                </video>
              </div>
            ))}
          </div>
        </section>

        {/* CTA */}
        <div className="flex flex-col sm:flex-row gap-4 justify-center">
          <Link
            to="/contact"
            className="bg-red-600 text-white px-6 py-3 rounded-lg font-semibold text-center hover:bg-red-700 transition"
          >
            Kostenlose Renovierungsberatung anfragen
          </Link>
          <a
            href="tel:+4917657122695"
            className="border-2 border-red-600 text-red-600 px-6 py-3 rounded-lg font-semibold text-center hover:bg-red-600 hover:text-white transition"
          >
            Anrufen
          </a>
        </div>

        <div className="space-y-20"> {/* Abstand zum Footer */}
        </div>
      </div>
    </div>
  );
};

export default About;